import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { FirstClassRecipeBaseEffect } from './first-class-recipe-base.effect';

@NgModule({
  imports: [
    EffectsModule.forFeature([ FirstClassRecipeBaseEffect ])
  ]
})
export class FirstClassRecipeBaseModule {

}
